var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoFooter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1397px",
    height: "500px",
    viewBox: "0 0 1397 500",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "\u7F16\u7EC4 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    cx: "50%",
    cy: "50%",
    fx: "50%",
    fy: "50%",
    r: "105.864984%",
    gradientTransform: "translate(0.500000,0.500000),scale(1.000000,0.987500),rotate(-90.000000),translate(-0.500000,-0.500000)",
    id: "radialGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "25.1629307%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#767676",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M168.485073,388.630874 C128.645562,365.76322 101.852871,327.603331 92.6407725,286.073082 C88.7996998,269.371305 102.748533,252.525817 120.538439,252.382105 L232.085723,252.208513 C242.603433,252.032609 251.977436,257.413234 257.083063,266.556845 L312.705491,362.684905 C322.256425,378.522104 313.77576,398.506289 296.07432,403.878287 C254.180412,415.038477 208.324583,411.498527 168.485073,388.630874 Z M380.331386,248.400704 L268.784102,248.574297 C258.266392,248.750201 248.892389,243.369576 243.786762,234.225965 L188.164334,138.097905 C179.394566,122.709092 186.643058,103.053147 203.563331,97.2327632 C244.345912,84.3991767 290.982908,88.3875117 330.822418,111.255165 C370.661929,134.122819 397.45462,172.282708 406.666719,213.812958 C412.400285,232.636517 398.902459,248.705379 380.331386,248.400704 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-17.1%",
    y: "-16.9%",
    width: "134.2%",
    height: "133.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 0,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 18,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.10470389 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-4"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "\\u692D\\u5706\\u5F62",
    cx: 250,
    cy: 250,
    r: 250
  })), /*#__PURE__*/React.createElement("g", {
    id: "ABEx",
    transform: "translate(600.000000, 145.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,210 L46.4941664,210 L78.8901016,154.8 L164.079413,154.8 L173.678209,210 L217.472714,210 L177.577719,0 L128.383892,0 L0,210 Z M99.2875423,120 L144.881822,42.6 L158.080166,120 L99.2875423,120 Z M279.864885,0 L235.170493,210 L342.856982,210 C388.451261,210 422.946933,181.5 422.946933,143.1 C422.946933,126.3 413.948062,112.2 398.949944,103.5 C419.347384,92.4 432.845691,72.6 432.845691,50.1 C432.845691,19.8 408.248777,0 370.153557,0 L279.864885,0 Z M363.254422,36 C379.45239,36 389.351148,44.1 389.351148,57.3 C389.351148,73.8 375.252917,85.8 356.055326,85.8 L304.161837,85.8 L314.660519,36 L363.254422,36 Z M343.756869,174 L285.56417,174 L296.96274,119.7 L351.255928,119.7 C369.25367,119.7 380.052315,128.4 380.052315,142.8 C380.052315,161.1 365.054196,174 343.756869,174 Z M455.342868,210 L617.922469,210 L617.922469,172.2 L498.837411,172.2 L498.837411,122.4 L576.527663,122.4 L576.527663,85.8 L498.837411,85.8 L498.837411,37.8 L616.722619,37.8 L616.722619,0 L455.342868,0 L455.342868,210 Z M629.321039,210 L675.21528,210 L712.110651,160.2 L749.006022,210 L797,210 L735.807678,129.9 L793.400452,53.7 L747.206248,53.7 L713.010538,100.2 L678.514866,53.7 L630.820851,53.7 L689.313511,130.5 L629.321039,210 Z",
    id: "\\u5F62\\u72B6\\u7ED3\\u5408"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "\\u5F62\\u72B6\\u7ED3\\u5408",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#radialGradient-1)",
    xlinkHref: "#path-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoFooter);
export default __webpack_public_path__ + "static/media/logo-footer.9e1297c4621d8f1caa1cae15a3a365a0.svg";
export { ForwardRef as ReactComponent };